export default {
	'Wx.PleaseClickInTheUpperRightCornerToShare': '请点击右上角【...】分享'
};
